<script setup>
import {computed} from 'vue'

import FormDisplayOrderMenu from "@/common/form/FormDisplayOrderMenu"
import PageEditorDetachFromPageBtn from "@/common/form/PageEditorDetachFromPageBtn"
import FormDuplicateBtn from "@/common/form/FormDuplicateBtn"
import FormDeleteBtn from "@/common/form/FormDeleteBtn"
import FormPublishBtn from "@/common/form/FormPublishBtn"

import {usePageEditorStore} from '@/stores/pageEditor'
import {useFormStore} from '@/stores/form'

const props = defineProps({
    formId: String
})

const pageEditorStore = usePageEditorStore()
const formStore = useFormStore(props.formId)

const pageContentId = computed(() => pageEditorStore.activePageContentId)
const pageContent = computed(() => pageEditorStore.contentItems.find(o => o.pageContentId === pageContentId.value))
const isHeaderOrFooterContent = computed(() => pageContent.value?.contentAreaName === 'Page header'
    || pageContent.value?.contentAreaName === 'Page footer')
const currentData = computed(() => formStore.currentData || {})
const showDisplayOrderOption = computed(() => formStore.showDisplayOrderOption)
</script>

<template>
    <div>
        <FormPublishBtn :form-id="formId" class="mb-3"/>
        <FormDisplayOrderMenu v-if="showDisplayOrderOption && currentData.id" :form-id="formId" class="mb-2"/>
        <FormDuplicateBtn v-if="!isHeaderOrFooterContent" :form-id="formId"/>
        <PageEditorDetachFromPageBtn :form-id="formId"/>
        <FormDeleteBtn :form-id="formId" :always-show="!isHeaderOrFooterContent"/>
    </div>
</template>